export default __webpack_public_path__ + "static/media/exploded-view_thumbnail.66e423e6.png";